import React from "react";
import { VscCalendar } from "react-icons/vsc";
import moment from "moment";
import SentimentBadge from "./SentimentBadge";
const NewsItem = ({ date, heading, content, url, sentiment, imageUrl }) => {
  return (
    <div className="NewsItem__container" style={{ color: "#777777" }}>
      <div>
        <img
          src={imageUrl}
          alt="Coinstorey_News_Image"
          style={{ width: "100%", height: "100%" }}
        />
      </div>
      <div>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              gap: "30px",
            }}
          >
            <p
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-end",
              }}
            >
              <VscCalendar size={18} />
              {moment(date).format("L")}
            </p>

            <SentimentBadge sentiment={sentiment} />
          </div>
        </div>
        <a href={url} rel="noopener noreferrer" target="_blank">
          <h2
            style={{ fontSize: "18px", lineHeight: "30px", marginTop: "10px" }}
          >
            {heading}
          </h2>
        </a>
        <p style={{ fontSize: "16px", lineHeight: "24px", marginTop: "10px" }}>
          {content}
        </p>
      </div>
    </div>
  );
};

export default NewsItem;
